var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CImg',{staticClass:"mx-auto d-block w-100 mb-3",staticStyle:{"max-width":"100px"},attrs:{"src":"//statics.affili.ir/storage/assets/empty-page.png"}}),_c('span',{staticClass:"h6 text-center d-block"},[_vm._v(_vm._s(_vm.message || _vm.$t("pagination.no_filtering_results")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }